import { NotificationIdentifier } from '@evorait/pace-core';

export const initialNotificationIdentifier: NotificationIdentifier = {
    frontId: '',
    qmNum: '',
    maNum: '',
};
